
import { useState } from 'react';

const ReviewsSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [selectedReview, setSelectedReview] = useState<typeof reviews[0] | null>(null);

  const reviews = [
    {
      id: 1,
      photo: 'https://public.readdy.ai/ai/img_res/647915188c86bd5cffcc5338b59d7f9f.jpg',
      name: 'Мария Иванова',
      rating: 5,
      shortText: 'Невероятное путешествие на Камчатку! Все было организовано на высшем уровне.',
      fullText: 'Это было невероятное путешествие на Камчатку! Все было организовано на высшем уровне. Гиды профессиональные, маршрут продуман до мелочей. Видели медведей, поднимались к вулканам, купались в горячих источниках. Особенно запомнился полет на вертолете над Долиной гейзеров. Команда MirSG сделала нашу мечту реальностью. Обязательно поедем с ними еще!'
    },
    {
      id: 2,
      photo: 'https://readdy.ai/api/search-image?query=Satisfied%20male%20traveler%20portrait%20after%20successful%20mountain%20expedition%20adventure%20gear%20background%20happy%20customer%20testimonial%20professional%20photography&width=80&height=80&seq=review-2&orientation=squarish',
      name: 'Алексей Петров',
      rating: 5,
      shortText: 'Восхождение на Эльбрус прошло безупречно. Команда профессионалов!',
      fullText: 'Восхождение на Эльбрус прошло безупречно. Команда профессионалов! Дмитрий, наш горный гид, обеспечил полную безопасность и помог каждому участнику достичь вершины. Акклиматизация была правильно организована, питание отличное. Это было настоящее испытание, но какое же удовольствие стоять на высшей точке России! Спасибо за незабываемые эмоции.'
    },
    {
      id: 3,
      photo: 'https://readdy.ai/api/search-image?query=Cheerful%20female%20traveler%20portrait%20after%20cultural%20tour%20ancient%20architecture%20background%20satisfied%20customer%20testimonial%20professional%20photography&width=80&height=80&seq=review-3&orientation=squarish',
      name: 'Елена Сидорова',
      rating: 5,
      shortText: 'Тур по Золотому кольцу превзошел все ожидания. Рекомендую!',
      fullText: 'Тур по Золотому кольцу превзошел все ожидания. Рекомендую! Анна, наш гид-историк, просто волшебница — она оживляла каждый камень древних городов. Посетили Суздаль, Владимир, Ростов Великий. В каждом городе узнали что-то новое и удивительное. Отели хорошие, транспорт комфортный. Это путешествие открыло для меня красоту родной страны с новой стороны.'
    },
    {
      id: 4,
      photo: 'https://readdy.ai/api/search-image?query=Happy%20couple%20travelers%20portrait%20after%20international%20adventure%20trip%20satisfied%20customers%20testimonial%20professional%20photography%20natural%20background&width=80&height=80&seq=review-4&orientation=squarish',
      name: 'Дмитрий и Ольга Морозовы',
      rating: 5,
      shortText: 'Медовый месяц в Исландии стал сказкой благодаря вашей организации.',
      fullText: 'Медовый месяц в Исландии стал сказкой благодаря вашей организации. Водопады, ледники, северное сияние — все это мы увидели за 10 дней. Особенно понравилось купание в Голубой лагуне и поездка по кольцевой дороге. Елена помогла нам с планированием маршрута, учла все наши пожелания. Каждый день был наполнен открытиями. Это лучшее начало семейной жизни!'
    },
    {
      id: 5,
      photo: 'https://readdy.ai/api/search-image?query=Enthusiastic%20young%20traveler%20portrait%20after%20adventure%20tour%20mountain%20background%20satisfied%20customer%20testimonial%20professional%20photography&width=80&height=80&seq=review-5&orientation=squarish',
      name: 'Антон Козлов',
      rating: 4,
      shortText: 'Байкал зимой — это что-то невероятное! Спасибо за яркие впечатления.',
      fullText: 'Байкал зимой — это что-то невероятное! Спасибо за яркие впечатления. Прозрачный лед, по которому можно ходить пешком, заснеженные берега, настоящая сибирская баня после ледяной прогулки. Жили в уютных домиках прямо на берегу. Единственное, что немного огорчило — погода была слишком ветреной в один из дней, пришлось изменить планы. Но в целом поездка удалась на все 200%!'
    },
    {
      id: 6,
      photo: 'https://readdy.ai/api/search-image?query=Joyful%20female%20senior%20traveler%20portrait%20after%20cultural%20expedition%20satisfied%20mature%20customer%20testimonial%20professional%20photography&width=80&height=80&seq=review-6&orientation=squarish',
      name: 'Людмила Васильевна',
      rating: 5,
      shortText: 'В 65 лет впервые поехала в горы. Это было потрясающе!',
      fullText: 'В 65 лет впервые поехала в горы. Это было потрясающе! Алтай встретил нас солнцем и невероятными пейзажами. Наши гиды очень внимательно отнеслись к возрастным особенностям группы, маршрут был адаптирован под наши возможности. Конные прогулки, рыбалка, вечера у костра — все было организовано идеально. Я поняла, что возраст не помеха для путешествий, если есть такие профессионалы рядом.'
    }
  ];

  const slidesPerView = 3;
  const totalSlides = reviews.length;
  const maxSlide = Math.max(0, totalSlides - slidesPerView);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev >= maxSlide ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev <= 0 ? maxSlide : prev - 1));
  };

  const goToSlide = (index: number) => {
    setCurrentSlide(Math.min(index, maxSlide));
  };

  const openModal = (review: typeof reviews[0]) => {
    setSelectedReview(review);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setSelectedReview(null);
    document.body.style.overflow = 'unset';
  };

  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, index) => (
      <i
        key={index}
        className={`ri-star-${index < rating ? 'fill' : 'line'} text-yellow-400`}
        aria-hidden="true"
      />
    ));
  };

  return (
    <>
      <section className="bg-white py-16 md:py-20 lg:py-24" aria-labelledby="reviews-heading">
        <div className="max-w-[1360px] mx-auto px-6">
          <div className="text-center mb-12">
            <h2 id="reviews-heading" className="font-mulish font-bold text-3xl lg:text-4xl text-gray-900 mb-6">
              Отзывы
            </h2>
          </div>

          <div className="relative" aria-live="polite" aria-label="Слайдер отзывов">
            {/* Слайдер */}
            <div className="overflow-hidden">
              <ul
                className="flex gap-6 transition-transform duration-500 ease-in-out"
                style={{ 
                  transform: `translateX(calc(-${currentSlide * (100/3)}% - ${currentSlide * 1.5}rem))` 
                }}
              >
                {reviews.map((review) => (
                  <li
                    key={review.id}
                    className="w-[calc(33.333%-1rem)] flex-shrink-0"
                  >
                    <article className="bg-gray-50 rounded-lg p-6 h-full flex flex-col hover:shadow-md transition-all duration-300">
                      <div className="flex items-center gap-4 mb-4">
                        <img
                          src={review.photo}
                          alt={`Фото ${review.name}`}
                          className="w-12 h-12 rounded-full object-cover object-top"
                          loading="lazy"
                        />
                        <div>
                          <h3 className="font-mulish font-semibold text-gray-900">
                            {review.name}
                          </h3>
                          <div 
                            className="flex items-center gap-1 mt-1"
                            role="img"
                            aria-label={`Оценка: ${review.rating} из 5 звезд`}
                          >
                            {renderStars(review.rating)}
                          </div>
                        </div>
                      </div>
                      <p className="font-open-sans text-sm text-gray-700 leading-relaxed flex-grow line-clamp-4">
                        {review.shortText}
                      </p>
                      <button
                        onClick={() => openModal(review)}
                        className="mt-4 font-open-sans text-[#1E88E5] hover:text-[#0D47A1] font-semibold text-sm transition-colors duration-300 self-start cursor-pointer"
                      >
                        Читать полностью
                      </button>
                    </article>
                  </li>
                ))}
              </ul>
            </div>

            {/* Навигация */}
            <div className="flex items-center justify-between mt-8">
              {/* Пагинация (точки) - слева */}
              <div className="flex items-center gap-2">
                {Array.from({ length: maxSlide + 1 }).map((_, index) => (
                  <button
                    key={index}
                    onClick={() => goToSlide(index)}
                    className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                      currentSlide === index
                        ? 'bg-[#1E88E5] w-8'
                        : 'bg-gray-300 hover:bg-gray-400'
                    }`}
                    aria-label={`Перейти к слайду ${index + 1}`}
                  />
                ))}
              </div>

              {/* Кнопки навигации - справа */}
              <div className="flex items-center gap-3">
                <button
                  onClick={prevSlide}
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 hover:bg-[#1E88E5] transition-colors duration-300 cursor-pointer group"
                  aria-label="Предыдущий слайд"
                >
                  <i className="ri-arrow-left-s-line text-xl text-gray-700 group-hover:text-white transition-colors duration-300"></i>
                </button>
                <button
                  onClick={nextSlide}
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 hover:bg-[#1E88E5] transition-colors duration-300 cursor-pointer group"
                  aria-label="Следующий слайд"
                >
                  <i className="ri-arrow-right-s-line text-xl text-gray-700 group-hover:text-white transition-colors duration-300"></i>
                </button>
              </div>
            </div>
          </div>

          {/* Ссылка на все отзывы */}
          <div className="text-center mt-12">
            <a
              href="/stories"
              className="font-open-sans text-[#1E88E5] hover:text-[#0D47A1] font-semibold transition-colors duration-300 cursor-pointer"
            >
              Читать истории участников
            </a>
          </div>
        </div>
      </section>

      {/* Модальное окно */}
      {selectedReview && (
        <div 
          className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50"
          aria-modal="true"
          role="dialog"
          aria-labelledby="modal-title"
        >
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex items-start justify-between mb-6">
                <div className="flex items-center gap-4">
                  <img
                    src={selectedReview.photo}
                    alt={`Фото ${selectedReview.name}`}
                    className="w-16 h-16 rounded-full object-cover object-top"
                  />
                  <div>
                    <h3 id="modal-title" className="font-mulish font-bold text-xl text-gray-900">
                      {selectedReview.name}
                    </h3>
                    <div 
                      className="flex items-center gap-1 mt-2"
                      role="img"
                      aria-label={`Оценка: ${selectedReview.rating} из 5 звезд`}
                    >
                      {renderStars(selectedReview.rating)}
                    </div>
                  </div>
                </div>
                <button
                  onClick={closeModal}
                  className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 transition-colors duration-300 cursor-pointer"
                  aria-label="Закрыть отзыв"
                >
                  <i className="ri-close-line text-xl"></i>
                </button>
              </div>
              <p className="font-open-sans text-gray-700 leading-relaxed">
                {selectedReview.fullText}
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ReviewsSection;
